<template>
  <div class="recommendations-page">
    <div class="page-header">
      <h1>Zalecenia</h1>
    </div>

    <div v-if="currentUser && pets" class="layout">
      <section class="section-card list-card">
        <div class="section-card-header">
          <h2>Lista zwierząt</h2>
        </div>

        <div class="pets-list" v-if="pets.length > 0">
          <div
              v-for="pet in pets"
              :key="pet.id"
              class="pet-item"
              :class="{ 'pet-item--active': currentPetId === pet.id }"
          >
            <div class="pet-item__left">
              <img :src="pet.photo_url ? pet.photo_url : getImageUrl()" :alt="pet.pet_name">
              <div class="pet-item__info">
                <b>{{ pet.pet_name }}</b>
              </div>
            </div>

            <button class="btn-icon" @click="setCurrentPet(pet.id)">
              <img src="@/assets/message-arrow.png" alt="szczegóły zalecenia">
            </button>
          </div>
        </div>

        <div v-else class="empty-state">
          <p>Brak zwierząt.</p>
        </div>
      </section>

      <section class="section-card details-card" v-if="currentPet">
        <div class="pet-header">
          <div class="pet-header__left">
            <img :src="currentPet.photo_url ? currentPet.photo_url : getImageUrl()" :alt="currentPet.pet_name">
            <h3>{{ currentPet.pet_name }}</h3>
          </div>
        </div>

        <div class="recomms-list" v-if="currentPet.recommendations && currentPet.recommendations.length > 0">
          <article class="recomm-item" v-for="recomm in currentPet.recommendations" :key="recomm.id">
            <div class="recomm-item__content">
              <span>{{ getRecommendationPreview(recomm.content) }}</span>

              <p
                  v-if="recomm.isExpanded && getRecommendationText(recomm.content).length > 90"
                  v-html="formatRecommendationText(getRecommendationText(recomm.content))"
              ></p>

              <a :href="recomm.photo_url" target="_blank" v-if="recomm.isExpanded && recomm.photo_url">zdjęcie 1</a>
              <a :href="recomm.second_photo_url" target="_blank" v-if="recomm.isExpanded && recomm.second_photo_url">zdjęcie 2</a>
            </div>

            <button class="btn-icon recomm-item__expand" @click="toggleRecommendation(recomm)">
              <img
                  src="@/assets/message-arrow.png"
                  :style="{ transform: `rotate(${recomm.isExpanded ? '90deg' : '-90deg'})` }"
                  alt="rozwiń"
              >
            </button>
          </article>
        </div>

        <div v-else class="empty-state">
          <p>Brak zaleceń dla tego zwierzęcia.</p>
        </div>
      </section>

      <section class="section-card details-card" v-else>
        <div class="empty-state">
          <p>Wybierz zwierzę z listy.</p>
        </div>
      </section>
    </div>

    <div v-else class="section-card">
      <div class="empty-state">
        <p>Brak zwierząt.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'PrivRecommendations',
  setup() {
    useMeta({ title: 'Zalecenia' });

    return {
      authStore: useAuthStore()
    };
  },
  data() {
    return {
      pets: null,
      currentPetId: null,
      currentPet: null
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 3) {
      this.$router.push('/login');
    }

    this.getPets();
  },
  methods: {
    getPets() {
      axios.get(`/User/${this.currentUser.id}`).then((res) => {
        this.pets = res.data.pets || [];
      }).catch(() => {});
    },
    getImageUrl() {
      return new URL(`../../assets/photo-placeholder.png`, import.meta.url).href;
    },
    setCurrentPet(petId) {
      this.currentPetId = petId;
      this.getPetData();
    },
    getPetData() {
      axios.get(`/Pet/${this.currentPetId}`).then((res) => {
        this.currentPet = res.data[0];
        this.currentPet.recommendations.map((x) => {
          x.isExpanded = false;
          return x;
        });
      }).catch(() => {});
    },
    toggleRecommendation(recomm) {
      recomm.isExpanded = !recomm.isExpanded;
    },
    getRecommendationText(content) {
      return content.slice(content.indexOf('|') + 1);
    },
    getRecommendationPreview(content) {
      const text = this.getRecommendationText(content);
      return text.length > 90 ? `${text.slice(0, 90)}...` : text;
    },
    formatRecommendationText(text) {
      return text.replace(/\n/g, '<br>');
    }
  }
};
</script>

<style scoped lang="scss">
.recommendations-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}
.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
}

.layout {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 20px;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 20px;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0 0 12px 0;
  font-size: 2rem;
  color: #1f2937;
}

.pets-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 560px;
  overflow-y: auto;
  padding-right: 4px;
}
.pet-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #f97316;
  border-radius: 8px;
  padding: 10px;
}
.pet-item--active {
  border-left-color: #10b981;
  background: #f9fafb;
}
.pet-item__left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pet-item__left img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
}
.pet-item__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pet-item__info b {
  font-size: 1.4rem;
  color: #1f2937;
}

.details-card {
  min-height: 560px;
}
.pet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 10px;
  margin-bottom: 12px;
}
.pet-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.pet-header__left img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 50%;
}
.pet-header__left h3 {
  margin: 0;
  font-size: 2rem;
}

.recomms-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.recomm-item {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.recomm-item__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.recomm-item__content span,
.recomm-item__content p {
  font-size: 1.4rem;
  color: #374151;
  margin: 0;
}
.recomm-item__content a {
  color: #2563eb;
  text-decoration: none;
  font-size: 1.3rem;
}
.recomm-item__content a:hover {
  text-decoration: underline;
}

.btn-icon {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-icon img {
  width: 16px;
  height: 16px;
}

.empty-state {
  text-align: center;
  padding: 26px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
  }
  .details-card {
    min-height: auto;
  }
}

@media (max-width: 480px) {
  .recommendations-page {
    padding: 16px 12px;
  }
  .page-header h1 {
    font-size: 2.2rem;
  }
  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }
}
</style>